<template>
  <div class="manager_dashboard">
    <user-menu />
    <div class="wrapper">
      <div class="content-wrapper">
        <div class="container-wrapper center">
          <div>
            <GoBack />
            <h3 class="d-inline heading">
              {{ tasklist_name }}
            </h3>
          </div>
          <div class="heading-seperator"></div>

          <div style="clear: both" class="margin-bottom-10"></div>

          <div class="col-md-12 counter_subtask-list" id="tasks">
            <div v-for = "(subtask, stindex) in subtasks">
              <div class="subtask-wrapper">
                <h4 class="panel-title">
                  <b-link v-b-toggle="'collapse-' + subtask.id">
                    <span class="counter_subtask-list__counter"></span>
                    {{ subtask.name }}
                  </b-link>
                </h4>
                <b-collapse v-bind:id="'collapse-' + subtask.id" class="mt-2 subtask-wrapper">
                  <b-card>
                    <div class="col-md-12 override-padding counter_heading-list">
                      <div v-for = "(heading, index) in subtask.headings">
                        <b-link v-b-toggle="'collapse-' + subtask.id + '-' + heading.id" size="sm" class="sub-heading">
                          <span class="counter_heading-list__counter"></span>
                          {{ heading.name }}
                          <i class="fa fa-angle-down" aria-hidden="true"></i>
                        </b-link>
                        <b-collapse v-bind:id="'collapse-' + subtask.id + '-' + heading.id" class="mt-2 task-wrapper">
                          <div class="col-md-12 override-padding counter_task-list">
                            <div v-for = "task in heading.tasks">
                              <b-card class="float-left modal-task">
                                <div class="task-title">
                                  <span class="counter_task-list__counter"></span>
                                  {{ task.description }}
                                </div>
                                <div class="task-repetition" v-if="task.noofTimesDone > 0"
                                 @click="showCommentModal('' + task.id + '', '' + task.description +'')">Repetition: {{task.noofTimesDone}}</div>
                                <div class="mark-done-wrapper" v-if="task.noofTimesDone === null || !task.noofTimesDone">
                                  <input :value="task.id" type="checkbox" name="tasks_done" :id="task.id" v-model="tasks_done" class="markdone-checkbox""
                                  @click="openDailyCheckinModal('' + task.id + '', '' + task.description +'')">
                                  <label :for="task.id">Mark done</label>
                                </div>
                              </b-card>

                            </div>
                          </div>
                          <div style="clear: both;"></div>
                        </b-collapse>
                      </div>
                    </div>
                    <div class="col-md-12 override-padding counter_task-list">
                      <div v-for = "substasklisttask in subtask.tasks" class="task-wrapper">
                        <b-card class="float-left modal-task">
                          <div class="task-title">
                            <span class="counter_task-list__counter"></span>
                            {{ substasklisttask.description }}
                          </div>
                          <div class="task-repetition" v-if="substasklisttask.noofTimesDone > 0"
                            @click="showCommentModal('' + substasklisttask.id + '', '' + substasklisttask.description +'')">Repetition: {{substasklisttask.noofTimesDone}}</div>
                          <div class="mark-done-wrapper" v-if="substasklisttask.noofTimesDone === null || !substasklisttask.noofTimesDone">
                            <input :value="substasklisttask.id" type="checkbox" name="tasks_done" :id="substasklisttask.id" v-model="tasks_done" class="markdone-checkbox""
                            @click="openDailyCheckinModal('' + substasklisttask.id + '', '' + substasklisttask.description +'')">
                            <label :for="substasklisttask.id">Mark done</label>
                          </div>
                        </b-card>

                      </div>
                    </div>
                    <div style="clear: both;"></div>
                  </b-card>
                </b-collapse>
              </div>
            </div>

            <DailyCheckinTasklistModal id="daily-checkin-wrapper" :isModalVisible="isModalVisible" @close="isModalVisible = false">
                <div slot="header" class="daily-checkin-heading"><h5>{{taskDesc}}</h5></div>
                <div slot="body">
                  <div><hr></div>
                  <div class="row override-padding">
                  <div class="label col-xs-8 col-md-8 col-lg-8">Number of times performed the task:</div>
                  <div class="col-xs-4 col-md-4 col-lg-4">
                  <select v-model="noof_times_done" name="noof_times" class="select select input-height-25 col-xs-12 col-md-12 col-lg-12 input-height-25">
                     <option value="1">1</option>
                     <option value="2">2</option>
                     <option value="3">3</option>
                     <option value="4">4</option>
                     <option value="5">5</option>
                 </select>
                 </div>
                 </div>
                 <div class="margin-bottom-10" style="clear: both;"></div>
                 <div class="row override-padding">
                   <div class="col-xs-12 col-md-12 col-lg-12">
                   <textarea
                    v-model="comments"
                    placeholder="Add your comments"
                    class="textarea col-xs-12 col-md-12 col-lg-12 input-height-25"
                    maxlength="1000"
                    >
                  </textarea>
                   </div>
                  </div>
                   <div style="clear: both" class="margin-bottom-10"></div>
                   <div class="row override-padding">
                   <div class="col-xs-12 col-md-12 col-lg-12">
                    <button type="submit"
                        v-on:click="submitDailyCheckin()"
                        class="btn btn-red btn-md input-height-15"
                        ><b>Submit</b></button>
                    </div>
                   </div>
                </div>
                <div slot="footer" class="col-3 override-padding">
                </div>
             </DailyCheckinTasklistModal>

            <DailyCheckinCommentModal id="daily-checkin-view-wrapper" :isModalVisible="isCommentModalVisible" @close="isCommentModalVisible = false">
              <div slot="header" class="daily-checkin-heading"><h5>{{taskDesc}}</h5></div>
              <div slot="body">
                <div><hr></div>
                <div v-if="commentEditFlag == false" class="comment-wrapper override-padding">
                  <div class="float-left col-9 override-padding">
                    <div v-if="this.edit_comments != ''">
                      <span>Comments:</span> {{this.edit_comments}}
                    </div>
                    <div v-else>
                      <span></span>
                    </div>
                  </div>
                  <div class="float-right text-align-right col-3 override-padding">
                    <button type="submit"
                       v-on:click="commentEditFlag=true"
                       class="btn btn-red btn-md input-height-15"
                       >Edit</button>
                  </div>
                </div>
                <div v-if="commentEditFlag == true" class="comment-wrapper override-padding">
                  <div class="row override-padding">
                    <div class="label col-xs-8 col-md-8 col-lg-8">Number of times performed the task:</div>
                    <div class="col-xs-4 col-md-4 col-lg-4">
                      <select v-model="edit_noof_times_done" name="noof_times" class="select select input-height-25 col-xs-12 col-md-12 col-lg-12 input-height-25">
                        <option value="1">1</option>
                        <option value="2">2</option>
                        <option value="3">3</option>
                        <option value="4">4</option>
                        <option value="5">5</option>
                      </select>
                    </div>
                  </div>
                  <div class="margin-bottom-10" style="clear: both;"></div>
                  <div class="row override-padding">
                    <div class="col-xs-12 col-md-12 col-lg-12">
                      <textarea v-model="edit_comments" placeholder="Add your comments" class="textarea col-xs-12 col-md-12 col-lg-12 input-height-25"></textarea>
                    </div>
                  </div>
                  <div style="clear: both" class="margin-bottom-10"></div>
                  <div class="row override-padding">
                    <div class="col-xs-12 col-md-12 col-lg-12">
                      <button type="submit"
                        v-on:click="updateDailyCheckin()"
                        class="btn btn-red btn-md input-height-15"
                        ><b>Update</b></button>
                    </div>
                  </div>
                </div>
              </div>
              <div slot="footer" class="col-3 override-padding">
              </div>
            </DailyCheckinCommentModal>

            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>

import Vue from 'vue/dist/vue.esm';
import UserMenu from '../shared/user_menu.vue';
import GoBack from '../shared/goback.vue';
import DailyCheckinTasklistModal from './daily-checkin-tasklist-modal.vue';
import axios from 'axios';
import moment from 'moment';
import { store } from '../../store/store';
import router from '../../router/index.js';
import DailyCheckinCommentModal from './daily-checkin-tasklist-modal.vue';

Vue.filter('formatDate', function(value) {
  if (value) {
    return moment(String(value)).format('MMM DD, YYYY')
  }
});

export default {
        data() {
          return {
            'subtasks': [],
            'tasklist_id': '',
            'tasklist_name': '',
            'isModalVisible': false,
            'loading': false,
            'noof_times_done': 1,
            'comments': '',
            'open': true,
            'close': false,
            'page_loading': false,
            'tasks_done': [],
            'mentee_id': '',
            'task_id': '',
            'taskDesc': '',
            'isCommentModalVisible': false,
            'edit_comments': '',
            'commentEditFlag': false,
            'edit_noof_times_done': '',
            'edit_checkin_id': '',
            }
        },
        components: {
          UserMenu,
          GoBack,
          DailyCheckinTasklistModal,
          DailyCheckinCommentModal
        },
        methods: {
          closeModal() {
            this.isModalVisible = false;
            this.$emit('close');
          },
          showTasks(tasklist_id) {
             axios.get('/daily-checkin-tasklist-details/' + tasklist_id, {

             })
             .then(response =>  {
                this.page_loading = false;
                this.subtasks = response.data.subtasks;
                this.tasklist_name = response.data.title;
             })
             .catch(function(error) {

             });
           },
           openDailyCheckinModal(taskId, taskTitle) {
             var taskSelected = document.getElementById(taskId).checked;
             if(taskSelected) {
               this.task_id = taskId;
               this.tasks_done.push(taskId);
               this.taskDesc = taskTitle;
               this.isModalVisible = true;
             }
           },
           showCommentModal(taskId, taskTitle) {
              this.taskDesc = taskTitle;
              this.edit_comments = '';
              this.edit_noof_times_done = '';
              this.edit_checkin_id = '';
              axios.get('/daily-checkin/view/' + taskId + '/' + this.tasklist_id, {

              })
              .then(response =>  {
                  this.isCommentModalVisible = true;
                  this.edit_comments = response.data[0].comment;
                  this.edit_noof_times_done = response.data[0].noofTimesDone;
                  this.edit_checkin_id = response.data[0].id;
              })
              .catch(function(error) {

              });
           },
           submitDailyCheckin() {
             var userAccountId = '';
             if(store.state.user_accountid) {
               userAccountId = store.state.user_accountid;
             }
             axios('/daily-checkin',
                {
                  method: 'POST',
                  data: {
                         accountId: userAccountId,
                         tasklistId: this.tasklist_id,
                         taskId: this.task_id,
                         noofTimesDone: this.noof_times_done,
                         comment: this.comments,
                         },
                }
              )
             .then((resp) => {
                this.isModalVisible = false;
                this.noof_times_done = 1;
                this.comments = '';
                this.edit_comments = '';
                this.edit_noof_times_done = '';
                this.edit_checkin_id = '';
                this.commentEditFlag = false,
                this.showTasks(this.tasklist_id);
              })
             .catch(error => {

             });
           },
           updateDailyCheckin() {
             axios('/daily-checkin/' + this.edit_checkin_id,
                {
                  method: 'PATCH',
                  data: {
                         noofTimesDone: this.edit_noof_times_done,
                         comment: this.edit_comments,
                         },
                }
              )
             .then((resp) => {
                this.isCommentModalVisible = false;
                this.noof_times_done = 1;
                this.comments = '';
                this.edit_comments = '';
                this.edit_noof_times_done = '';
                this.edit_checkin_id = '';
                this.commentEditFlag = false,
                this.showTasks(this.tasklist_id);
              })
             .catch(error => {

             });
           },
        },
        created: function () {
          this.page_loading = true;
          this.tasklist_id = this.$route.params.tasklist_id;
          this.showTasks(this.tasklist_id);
        },
    }
</script>

<style scoped>
  .back-btn-wrapper {
    width:100%;
    margin-left: 10px;
    margin-right: 0px;
  }
  .modal-task .task-title {
    cursor: none;
  }
  .markdone-checkbox {
	font:16pt FontAwesome;
	vertical-align:middle;
}
 .mark-done-wrapper {
  font-weight: bold;
  color: rgb(76, 148, 207);
  float: right;
  margin-right: 20px;
  margin-top: 5px;
 }
 .task-repetition {
  background-color: #5fba7d;
  width: 100px;
  color: #FFF;
  padding: 2px;
  text-align: center;
  border-radius: 15px;
  font-size: 15px;
  float: right;
  margin-right: 20px;
  cursor: pointer;
 }
 input[type="checkbox"] {
  position: absolute;
  opacity: 0;
  z-index: -1;
 }
 input[type="checkbox"]+label {
  color: rgb(76, 148, 207);
 }
 input[type="checkbox"]+label:before {
  font: 16pt FontAwesome;
  content: '\00f096';
  display: inline-block;
  width: 16pt;
  padding: 2px 0 0 3px;
  margin-right: 0.5em;
  margin-top: -3px;
  float: left;
 }
 input[type="checkbox"]:checked+label:before {
  content: '\00f046';
 }
 input[type="checkbox"]:focus+label:before {
  outline: 1px dotted #aaa;
 }
 .task-title {
   width: auto;
 }
 .task-item-list {
   margin-top: 0px;
 }
 h5 {
  font-size: 14px;
  font-weight: normal;
 }
.modal-body .label {
  color: #555;
  font-weight: bold;
}
#daily-checkin-wrapper hr, #daily-checkin-view-wrapper hr {
  border: 1px solid #000;
  margin-top: 0;
}
#daily-checkin-wrapper select {
  padding: 5px;
}
.comment-wrapper span {
  font-weight: bold;
}
hr {
  margin: 10px 0px;
}
.task-item-list {
  margin-top: 5px;
}
#tasks {
    margin-top: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/mentee/daily_checkin_tasklist_details.vue